import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { MessageService, ToastMessage } from '../../services/message.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast-container.component.html'
})
export class ToastContainerComponent implements OnInit, OnDestroy {
  toasts: ToastMessage[] = [];
  private sub = new Subscription();

  constructor(private messageService: MessageService) {}

  ngOnInit(): void {
    this.sub.add(this.messageService.messages$.subscribe((t) => this.showToast(t)));
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private showToast(toast: ToastMessage) {
    this.toasts.push(toast);
    const duration = toast.timeout ?? 4000;
    const s = timer(duration).subscribe(() => {
      this.remove(toast.id);
      s.unsubscribe();
    });
  }

  public remove(id: string) {
    this.toasts = this.toasts.filter((t) => t.id !== id);
  }
}
